import { createContext, useContext } from 'react';
const AccordionContext = createContext({
    activeItem: '',
    changeSelectedItem: () => { },
});
export default AccordionContext;
export const useAccordionContext = () => {
    const context = useContext(AccordionContext);
    if (!context) {
        throw new Error('Error in creating the context');
    }
    return context;
};
